import { makeStyles } from '@material-ui/core'
import { styled } from 'opensolar-ui'
import { Theme } from 'types/themes'

export const useResourceStyles = makeStyles((theme: Theme) => ({
  formSection: { margin: '20px 0', padding: 20 },
}))

export const FormSection = styled('div', { name: 'FormSection' })(({ theme }) => ({
  border: theme.mixins.borderStandard.border,
  borderColor: theme.palette.grey[300],
  borderRadius: 8,
  padding: '20px 25px',
  margin: '20px 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}))
export const FieldRow = styled('div', { name: 'FormRow' })(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '80%',
  },
}))

export const StyledSection = styled('section')({
  '.OSUI-FormControl-marginDense': { margin: '16px 30px 16px 0' },
  '[class*="RaSelectInput-input"]': {
    minWidth: 256,
  },
})
